// src/App.tsx

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./features/home/Home";
import { AuthProvider } from "./features/authentication/AuthContext";
import User from "./features/user/UserEdit";
import UserEdit from "./features/user/UserEdit";
import { useEffect } from "react";
import { themeChange } from "theme-change";
import Search from "./features/search/Search";
import { initializeAmplitude } from "./features/engagement/Amplitude";
import { QueryClient, QueryClientProvider } from "react-query";
import Importer from "./features/importer/Importer";
import Feedback from "./features/home/Feedback";
import { UtilityProvider } from "./features/shared/UtilityContext";
import ReactGA from "react-ga";
import EditTask from "./features/tasks/EditTask";
import MyTasks from "./features/tasks/MyTasks";
import NotFound from "./features/home/NotFound";
import MySaves from "./features/tasks/MySaves";
import ExtractionDemo from "./features/tools/ExtractionDemo";
import TaskDetails from "./features/tasks/TaskDetails";
import Explorer from "./features/tools/Explorer";
import CreateStep from "./features/tasks/CreateTask";
import CreateGuide from "./features/tasks/CreateGuide";
import GuideDetails from "./features/tasks/GuideDetails";
import GuideChat from "./features/tasks/GuideChat";
import DraftTasks from "./features/tasks/DraftTasks";
import EditDraftTask from "./features/tasks/EditDraftTask";
import Authorize from "./features/authentication/Authorize";
import NewSnippet from "./features/snippets/NewSnippet";
import SnippetConverter from "./features/snippets/components/SnippetConverter";
import JsonStringMaker from "./features/tools/JsonStringMaker";
import CodePost from "./features/tools/code_post/CodePost";
import StartAssist from "./features/tools/start_assist/StartAssist";
import SmartSnippets from "./features/tools/smart_snippets/SmartSnippets";

export const queryClient = new QueryClient();

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID || "");
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  useEffect(() => {
    themeChange(false);
  }, [localStorage.theme]);

  useEffect(() => {
    initializeAmplitude();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <UtilityProvider>
            <Routes>
              <Route
                path="/"
                Component={Home}
              />
              <Route
                path="/authorize"
                Component={Authorize}
              />
              <Route
                path="/snippet/new"
                Component={NewSnippet}
              />
              <Route
                path="/snippet/manual"
                Component={CreateStep}
              />
              <Route
                path="/snippet/me"
                Component={MyTasks}
              />
              <Route
                path="/snippet/:id/:slug?"
                Component={NewSnippet}
              />
              <Route
                path="/snippet/me/saves"
                Component={MySaves}
              />
              <Route
                path="/snippet/me/drafts"
                Component={DraftTasks}
              />
              <Route
                path="/snippet/me/drafts/edit/:id"
                Component={EditDraftTask}
              />
              <Route
                path="/snippet/edit/:id"
                Component={EditTask}
              />
              <Route
                path="/users/:id"
                Component={User}
              />
              <Route
                path="/users/edit/:id"
                Component={UserEdit}
              />
              <Route
                path="/chat"
                Component={GuideChat}
              />
              <Route
                path="/search"
                Component={Search}
              />
              <Route
                path="/feedback"
                Component={Feedback}
              />
              <Route
                path="/importer"
                Component={Importer}
              />
              <Route
                path="/extraction"
                Component={ExtractionDemo}
              />
              <Route
                path="/explorer"
                Component={Explorer}
              />
              <Route
                path="/tools/json-prompt-maker"
                Component={JsonStringMaker}
              />
              <Route
                path="/tools/code-post/:id"
                Component={CodePost}
              />
              <Route
                path="/tools/start-assist"
                Component={StartAssist}
              />
              <Route
                path="/tools/smart-snippets"
                Component={SmartSnippets}
              />
              <Route
                path="/guide/new"
                Component={CreateGuide}
              />
              <Route
                path="/guide/:guideId"
                Component={GuideDetails}
              />
              <Route
                path="*"
                Component={NotFound}
              />
            </Routes>
          </UtilityProvider>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
